<template>
  <div class="px-1 pb-2">
    <v-card class="mx-auto" v-if="showForm">
      <v-form ref="dform" lazy-validation @submit.prevent v-model="validForm">
        <v-row class="mx-10">
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="dform.fullname"
              label="Full Name"
              dense
              color="primary"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <v-text-field
              v-model="dform.username"
              label="Username"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="dform.passwd"
              label="Password"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-select
              v-model="dform.admin_level"
              label="Admin Level"
              :items="['admin', 'super admin']"
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" sm="3">
            <p>Is the admin active?</p>
            <v-radio-group v-model="dform.is_active" row>
              <v-radio label="Yes" color="green" :value="1"></v-radio>
              <v-radio label="No" color="red" :value="0"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row justify="center" class="">
          <v-btn
            v-if="!dform.id"
            :disabled="!validForm"
            :loading="loading"
            color="primary"
            @click="addRecord"
            class="mx-3 mb-3"
            >Add</v-btn
          >
          <v-btn
            v-else
            class="my-3"
            color="primary"
            :loading="loading"
            @click="saveChanges"
            >Save Changes</v-btn
          >
        </v-row>
      </v-form>
    </v-card>
    <hr class="secondary mb-5" />
    <v-data-table
      :headers="Headers"
      :items="admins"
      class="elevation-1"
      :search="search"
    >
      <template v-slot:top>
        <v-row justify="end" no-gutters>
          <v-col cols="12" class="mb-0">
            <v-btn text>Admins</v-btn>
            <span class="primary--text cursor-pointer" icon @click="newForm"
              ><v-icon color="secondary">mdi-plus-circle</v-icon> new
              admin</span
            >
          </v-col>
          <v-col cols="12" md="6" class="mb-5">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
      <template #item.is_active="{ value }">
        {{ +value ? "Yes" : "No" }}
      </template>
      <template #item.actions="{ item }">
        <v-icon
          icon
          small
          class="mr-2"
          @click="editForm(item)"
          title="Click to edit"
          color="secondary"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          icon
          small
          @click="delRecord(item)"
          title="Click to delete"
          color="error"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
    <v-snackbar v-model="snackbar" bottom :color="snackColor">
      <p>{{ snackMsg }}</p>
      <template v-slot:action="{ attrs }">
        <v-btn dark v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { apiClient } from "@/services";
import { mapState } from "vuex";
import { snackMixin } from "@/mixins";
export default {
  name: "Alladmin",
  mixins: [snackMixin],
  data() {
    return {
      expanded: [],
      search: "",
      showForm: false,
      validForm: true,
      loading: false,
      panel: [0, 1, 2],
      disabled: false,
      Headers: [
        { text: "Full Name", value: "fullname" },
        { text: "Username", value: "username" },
        { text: "Admin Level", value: "admin_level" },
        { text: "Active", value: "is_active" },
        { text: "", value: "actions" },
      ],
      admins: [],
      dform: this.initializeForm(),
    };
  },
  computed: {
    ...mapState(["curUser"]),
  },
  created() {
    apiClient
      .get("/admins?u=2")
      .then((res) => {
        if (Array.isArray(res.data)) {
          this.admins = res.data;
        } else {
          this.displayMsg(res.data, "error");
        }
      })
      .catch((err) => this.displayMsg(err.message));
  },
  methods: {
    initializeForm() {
      return {
        fullname: "",
        username: "",
        passwd: "",
        admin_level: "",
        is_active: "",
      };
    },
    delRecord(record) {
      const ok = confirm(`Are you sure you want to delete ${record.fullname}?`);
      if (ok) {
        this.displayMsg(`Deleting ${record.fullname}, please wait...`);
        apiClient
          .delete(`/admins?${record.id}`)
          .then((res) => {
            if (!res.data.ok) {
              this.displayMsg(
                `${record.fullname} not successfully deleted`,
                "error"
              );
              return;
            }
            this.admins = this.admins.filter((rec) => rec.id !== record.id);
            this.displayMsg(`${record.fullname} successfully deleted`);
          })
          .catch((err) => this.displayMsg(`${err.message}`, "error"));
      }
    },
    async addRecord() {
      if (!this.$refs.dform.validate()) {
        return;
      }
      this.loading = true;
      try {
        const res = await apiClient.post("/admins", this.dform);
        if (res.data.id) {
          this.admins.push(res.data);
          this.dform = this.initializeForm();
          this.displayMsg("Admin added successfully");
          this.showForm = false;
        } else {
          this.displayMsg(res.data, "error");
        }
      } catch (err) {
        this.displayMsg(err, "error");
      }
      this.loading = false;
    },
    editForm(item) {
      this.dform = item;
      this.showForm = true;
    },
    newForm() {
      this.dform = this.initializeForm();
      this.showForm = true;
    },
    async saveChanges() {
      if (!this.$refs.dform.validate()) {
        return;
      }
      this.loading = true;
      this.dform.type = "superadmin";
      try {
        const res = await apiClient.put("/admins", this.dform);
        if (res.data.ok) {
          this.displayMsg("Changes saved successfully");
          this.dform = this.initializeForm();
          this.showForm = false;
        } else {
          this.displayMsg("Not successfully added", "error");
        }
      } catch (err) {
        this.displayMsg(err);
      }
      this.loading = false;
    },
  },
};
</script>
